const getPersianLabel = (item) => {
  switch (item) {
    case 1:
      return "یک ";
    case 2:
      return "دو ";
    case 3:
      return "سه ";
    case 4:
      return "چهار ";
    case 5:
      return "پنج ";
    case 6:
      return "شش ";
    case 7:
      return "هفت ";
    case 8:
      return "هشت ";
    case 9:
      return "نه ";
    case 10:
      return "ده ";
    case 11:
      return "یازده ";
  }
};

export const getSubscriptionLabel = (period) => {
  if (period > 12) return period + "ماهه";
  else {
    const hasYear = period % 12 == 0;
    if (hasYear) return getPersianLabel(period / 12) + "ساله";
    else return getPersianLabel(period) + "ماهه";
  }
};
